export default {
    STARTED: 'submitStarted',
    SUBMITED: 'submited',
    RESUBMITED: 'resubmited',
    FAILED: 'submitFailed',
    SYNCED: 'synced',
    RESYNCED: 'resync',
};
